exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".parentInfoModal .inputContainer{display:inline-block;margin:5px;width:47%}.parentInfoModal .inputContainer .inputLabel{margin-bottom:5px;font-weight:700}.parentInfoModal .terms{font-size:.8em;margin-top:15px;width:60%;margin-left:20%;text-align:center}.parentInfoModal .buttonSuccess{margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/parents/parent_info_modal.scss
// module id = 1423
// module chunks = 0